import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Ruler } from 'lucide-react';

export const SizeGuideModal = ({ open, onOpenChange, slug }) => {
    const [guide, setGuide] = useState(null);
    useEffect(() => {
        if (!slug || !open) return;
        api.get(`/size-guides/${slug}`).then(r => setGuide(r.data)).catch(() => setGuide(null));
    }, [slug, open]);

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-2xl" data-testid="size-guide-modal">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2"><Ruler className="h-5 w-5 text-red-600" />Guía de tallas</DialogTitle>
                    {guide && <DialogDescription>{guide.name}</DialogDescription>}
                </DialogHeader>
                {!guide ? <div className="text-sm text-muted-foreground">Cargando…</div> : (
                    <div className="space-y-3">
                        <div className="overflow-x-auto rounded-xl border">
                            <table className="w-full text-sm">
                                <thead className="bg-red-600 text-white">
                                    <tr>{guide.headers.map((h, i) => (
                                        <th key={i} className="px-3 py-2 text-left font-medium">{h}</th>
                                    ))}</tr>
                                </thead>
                                <tbody>
                                    {guide.rows.map((row, i) => (
                                        <tr key={i} className={i % 2 ? 'bg-neutral-50' : ''}>
                                            {row.map((cell, j) => (
                                                <td key={j} className="px-3 py-2 tabular-nums">{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        {guide.tip && (
                            <div className="rounded-lg bg-red-50 border border-red-200 p-3 text-xs text-red-900">
                                <b>Tip:</b> {guide.tip}
                            </div>
                        )}
                    </div>
                )}
            </DialogContent>
        </Dialog>
    );
};
